<app-navbar [navList]="navList"></app-navbar>

<div class="row qai-content-box overflow-auto">

    @if (contextDetail(); as contextDetail) {
    <div class="col-md-4 p-4 pe-2">

        <p class="fw-bolder" i18n>Gruppi Disponibili</p>

        @if (groups(); as groups) {
        @let filteredGroups = filterGroups(groups, contextDetail.groups);

        <ul class="list-group shadow-sm">
            @for (group of filteredGroups; track group.id) {
            <li
                class="list-group-item qai-linkable-item d-flex justify-content-between align-items-start p-0 border border-0">
                <div class="ms-2 me-auto p-3 text-truncate" style="height: 100%;">
                    <div class="fw-bolder text-truncate" style="height: 1.5em; overflow: hidden;">{{ group.name }}</div>
                    <div style="height: 1.5em; overflow: hidden;">{{ group.description }}</div>
                </div>
                <span class="p-3 qai-user-count">
                    {{ group.userCount }}
                    <fa-icon [icon]="faUser" size="sm"></fa-icon>
                </span>
                <div class="align-self-center">
                    <button type="button" class="btn btn-primary tas-link-entity-button shadow ps-4 pe-3"
                        (click)="addGroupToContext(group.id)">
                        <span class="me-2">Aggiungi</span>
                        <fa-icon [icon]="faArrowRight" size="lg"></fa-icon>
                    </button>
                </div>
            </li>
            }
            @empty {
            <li class="list-group-item border border-0 p-3 text-muted text-center" i18n>
                Nessun gruppo disponibile
            </li>
            }
        </ul>
        } @else if (groupsResource.isLoading()) {

        <ul class="list-group shadow-sm" aria-busy="true">
            @for (i of [1, 2, 3]; track i) {
            <li class="list-group-item d-flex justify-content-between align-items-start p-0 border border-0">
                <div class="ms-2 me-auto p-3 w-75 placeholder-glow">
                    <div style="height: 1.5em;">
                        <span class="placeholder col-6" aria-hidden="true"></span>
                    </div>
                    <div style="height: 1.5em;">
                        <span class="placeholder col-8" aria-hidden="true"></span>
                    </div>
                </div>
                <span class="p-3 placeholder-glow">
                    <span class="placeholder px-4" aria-hidden="true"></span>
                </span>
            </li>
            }
        </ul>
        }
    </div>

    <div class="col-md-8 p-4 ps-2">

        <div class="card te-ouline-border shadow-sm">
            <form [formGroup]="contextForm" (ngSubmit)="updateContext()">
                <div class="card-body">
                    <p class="ps-2">
                        @if (contextDetail.status !== 'COMPLETED') {
                        <span class="badge me-2" [ngClass]="{
                                'qai-bg-danger': contextDetail.status === 'FAILED',
                                'qai-bg-deleted': contextDetail.status === 'IDLE',
                                'qai-bg-secondary': contextDetail.status === 'PENDING'
                              }" style="font-size: 1.1em;">
                            {{ statusTranslationMap[contextDetail.status] || contextDetail.status }}
                        </span>
                        } @else {
                        <span class="badge" [ngClass]="{
                                'qai-bg-success': contextDetail?.integrationStatus === 'FRONTEND_INTEGRATION_ALLOWED',
                                'qai-bg-info': contextDetail?.integrationStatus === 'BACKEND_INTEGRATION_ONLY',
                                'qai-bg-warning': contextDetail?.integrationStatus === 'DISABLED',
                              }" style="font-size: 1.1em;">
                            {{ integrationStatusTranslationMap[contextDetail.integrationStatus] ||
                            contextDetail.integrationStatus }}
                        </span>
                        }
                    </p>
                    <div class="card-title d-flex">
                        <div class="col-9 me-auto">
                            <input type="text" class="form-control qai-card-form qai-card-form_title" id="name"
                                formControlName="name" i18n-aria-label aria-label="input group name">
                        </div>
                        @if (!editMode) {
                        <button class="btn btn-light rounded-3 py-1 my-1" type="button" (click)="toggleEditMode(true)"
                            i18n>
                            Modifica
                        </button>
                        } @else {
                        <button class="btn btn-light rounded-3 py-1 my-1" type="submit" i18n>
                            Salva
                        </button>
                        }
                        @if (contextDetail) {
                        <button type="button" class="btn btn-link p-0 mx-3" (click)="openSettings(contextDetail)"
                            aria-label="Settings">
                            <fa-icon [icon]="faCog" size="lg"></fa-icon>
                        </button>
                        }
                    </div>
                    <div class="card-subtitle mb-3">
                        <div class="col-9">
                            <input type="text" class="form-control qai-card-form fst-italic" id="description"
                                formControlName="description" i18n-aria-label aria-label="input group description">
                        </div>
                    </div>
                    <button class="btn btn-primary" type="button" (click)="openSeachLink()" i18n>
                        Ottieni link Search
                    </button>
                </div>
            </form>
        </div>

        <div class="my-3">
            <app-list [items]="contextDetail.groups || []" [columns]="['name', 'description']" [loading]="loading"
                (deleteRow)="removeGroupFromContext($event, 'remove')" (rowClick)="openGroupDetail($event)">
            </app-list>
        </div>

    </div>
    } @else if (contextResource.isLoading()) {

    <!-- Skeleton completo: contesto in caricamento -->
    <div class="col-md-4 p-4 pe-2" aria-busy="true">
        <p class="fw-bolder placeholder-glow">
            <span class="placeholder col-6" aria-hidden="true"></span>
        </p>

        <ul class="list-group shadow-sm">
            @for (i of [1, 2]; track i) {
            <li class="list-group-item d-flex justify-content-between align-items-start p-0 border border-0">
                <div class="ms-2 me-auto p-3 w-75 placeholder-glow">
                    <div style="height: 1.5em;">
                        <span class="placeholder col-6" aria-hidden="true"></span>
                    </div>
                    <div style="height: 1.5em;">
                        <span class="placeholder col-8" aria-hidden="true"></span>
                    </div>
                </div>
                <span class="p-3 placeholder-glow">
                    <span class="placeholder px-4" aria-hidden="true"></span>
                </span>
            </li>
            }
        </ul>
    </div>

    <div class="col-md-8 p-4 ps-2" aria-busy="true">
        <div class="card shadow-sm">
            <div class="card-body placeholder-glow">
                <!-- badge stato -->
                <p class="ps-2">
                    <span class="placeholder col-2 rounded-pill" style="height: 1.6em;" aria-hidden="true"></span>
                </p>

                <!-- titolo + pulsanti -->
                <div class="d-flex align-items-center mb-2">
                    <div class="col-9 me-auto">
                        <span class="placeholder col-7 placeholder-lg" aria-hidden="true"></span>
                    </div>
                    <a class="btn btn-light disabled placeholder col-1 me-3" aria-hidden="true"></a>
                    <span class="placeholder col-1" aria-hidden="true"></span>
                </div>

                <!-- descrizione -->
                <div class="mb-3">
                    <span class="placeholder col-5" aria-hidden="true"></span>
                </div>

                <!-- pulsante link search -->
                <a class="btn btn-primary disabled placeholder col-2" aria-hidden="true"></a>
            </div>
        </div>

        <!-- tabella gruppi associati -->
        <div class="my-3 placeholder-glow">
            <div class="card shadow-sm">
                <div class="card-body">
                    @for (i of [1, 2]; track i) {
                    <div class="d-flex gap-3 mb-3">
                        <span class="placeholder col-3" aria-hidden="true"></span>
                        <span class="placeholder col-6" aria-hidden="true"></span>
                        <span class="placeholder col-1 ms-auto" aria-hidden="true"></span>
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    }

</div>